var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGym(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1 11H6.9C6.66131 11 6.43239 11.0948 6.2636 11.2636C6.09482 11.4324 6 11.6613 6 11.9V25.1C6 25.2182 6.02328 25.3352 6.06851 25.4444C6.11374 25.5536 6.18003 25.6528 6.2636 25.7364C6.34718 25.82 6.44639 25.8863 6.55558 25.9315C6.66478 25.9767 6.78181 26 6.9 26H11.1C11.2182 26 11.3352 25.9767 11.4444 25.9315C11.5536 25.8863 11.6528 25.82 11.7364 25.7364C11.82 25.6528 11.8863 25.5536 11.9315 25.4444C11.9767 25.3352 12 25.2182 12 25.1V11.9C12 11.6613 11.9052 11.4324 11.7364 11.2636C11.5676 11.0948 11.3387 11 11.1 11V11Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1 11H24.9C24.6613 11 24.4324 11.0948 24.2636 11.2636C24.0948 11.4324 24 11.6613 24 11.9V25.1C24 25.2182 24.0233 25.3352 24.0685 25.4444C24.1137 25.5536 24.18 25.6528 24.2636 25.7364C24.3472 25.82 24.4464 25.8863 24.5556 25.9315C24.6648 25.9767 24.7818 26 24.9 26H29.1C29.2182 26 29.3352 25.9767 29.4444 25.9315C29.5536 25.8863 29.6528 25.82 29.7364 25.7364C29.82 25.6528 29.8863 25.5536 29.9315 25.4444C29.9767 25.3352 30 25.2182 30 25.1V11.9C30 11.6613 29.9052 11.4324 29.7364 11.2636C29.5676 11.0948 29.3387 11 29.1 11V11Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 22.1V14.9C1.5 14.6613 1.59482 14.4324 1.7636 14.2636C1.93239 14.0948 2.16131 14 2.4 14H5.1C5.33869 14 5.56761 14.0948 5.7364 14.2636C5.90518 14.4324 6 14.6613 6 14.9V22.1C6 22.3387 5.90518 22.5676 5.7364 22.7364C5.56761 22.9052 5.33869 23 5.1 23H2.4C2.16131 23 1.93239 22.9052 1.7636 22.7364C1.59482 22.5676 1.5 22.3387 1.5 22.1V22.1Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 22.1V14.9C34.5 14.6613 34.4052 14.4324 34.2364 14.2636C34.0676 14.0948 33.8387 14 33.6 14H30.9C30.6613 14 30.4324 14.0948 30.2636 14.2636C30.0948 14.4324 30 14.6613 30 14.9V22.1C30 22.3387 30.0948 22.5676 30.2636 22.7364C30.4324 22.9052 30.6613 23 30.9 23H33.6C33.8387 23 34.0676 22.9052 34.2364 22.7364C34.4052 22.5676 34.5 22.3387 34.5 22.1V22.1Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.5H24",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGym);
export default __webpack_public_path__ + "static/media/gym.840057818023b1265726a45cf5019b12.svg";
export { ForwardRef as ReactComponent };